<template>
  <div>
    <div class="tab-plan verify-tab">
      <div v-if="showKycTips" class="kyc-tips">
        <!-- 有第三方 kyc 驗證 -->
        <template v-if="kyc_brand">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon_alert.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            <template v-if="memberInfo.is_pass_KYC === 1">
              {{ $t("Bao.KYC_has_third_completed") }}
            </template>
            <template v-else-if="isSetData">
              {{ $t("Bao.KYC_need_third_completed") }}
            </template>
            <template v-else>
              {{ $t("Bao.KYC_has_third_not_complete") }}
            </template>
          </p>
          <div
            v-if="memberInfo.is_pass_KYC !== 1 && isSetData"
            class="btn btn-style-primary kyc-bn-gold"
            @click="save()"
          >
            {{ $t("Bao.KYC_has_third_completed_btn") }}
          </div>
        </template>
        <!-- 未經過驗證 -->
        <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 0">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            <span class="t-highlight">{{ $t("Bao.KYC_not_complete_1") }}</span>
            {{ $t("Bao.KYC_not_complete_2") }}
          </p>
        </template>
        <!-- 已驗證 -->
        <template v-if="!kyc_brand && memberInfo.is_pass_KYC === 1">
          <i class="icon-alert">
            <img :src="$getThemeImagePath('icon-alert-kyc.png')" alt="">
          </i>
          <p class="kyc-tipContent">
            {{ $t("Bao.KYC_has_completed_1") }}
            <span class="t-highlight">{{ $t("Bao.KYC_has_completed_2") }}</span>
            {{ $t("Bao.KYC_has_completed_3") }}
            <span class="t-highlight"> {{ $t("Bao.KYC_has_completed_4") }}</span>
            {{ $t("Bao.KYC_has_completed_5") }}
          </p>
        </template>
      </div>

      <div class="verify-form">
        <div class="verify-form-title">
          {{ $t('Bao.personal_info') }}
        </div>

        <div class="row-frame gx-3 gy-3">
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t('Bao.last_name') }}
              <span class="t-highlight">＊</span>
            </label>
            <template v-if="memberInfo.name">
              <input
                v-model="lastName"
                class="for-input inpType"
                type="text"
                disabled
              >
            </template>
            <template v-else>
              <input
                v-model="lastName"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('last_name')}"
                type="text"
                name="last_name"
                :data-vv-as="$t('Bao.last_name')"
                :placeholder="$t('Bao.name_content')"
              >
            </template>
            <div v-if="errors.has('last_name')" class="input-feedback text-align-R">
              {{ $t('Bao.last_name_error') }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t('Bao.first_name') }}
              <span class="t-highlight">＊</span>
            </label>
            <template v-if="memberInfo.name">
              <input
                v-model="firstName"
                type="text"
                class="for-input inpType"
                disabled
              >
            </template>
            <template v-else>
              <input
                v-model="firstName"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('first_name')}"
                type="text"
                name="first_name"
                :data-vv-as="$t('Bao.first_name')"
                :placeholder="$t('Bao.name_content')"
              >
            </template>
            <div v-if="errors.has('first_name')" class="input-feedback text-align-R">
              {{ $t('Bao.first_name_error') }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t('Bao.romanization_of_last_name') }}
              <span class="t-highlight">＊</span>
            </label>
            <template v-if="memberInfo.romanization">
              <input
                v-model="romanizationOfLastName"
                type="text"
                class="for-input inpType"
                disabled
              >
            </template>
            <template v-else>
              <input
                v-model="romanizationOfLastName"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('romanizationOfLastName') || romanLastError }"
                type="text"
                name="romanizationOfLastName"
                :data-vv-as="$t('Bao.romanization_of_last_name')"
                @input="validateRomLastName"
              >
            </template>
            <div v-if="errors.has('romanizationOfLastName')" class="input-feedback text-align-R">
              {{ $t('Bao.romanization_of_last_name_error') }}
            </div>
            <div v-else-if="romanLastError" class="input-feedback text-align-R">
              {{ romanLastError }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t('Bao.romanization_of_first_name') }}
              <span class="t-highlight">＊</span>
            </label>
            <template v-if="memberInfo.romanization">
              <input
                v-model="romanizationOfFirstName"
                class="for-input inpType"
                type="text"
                disabled
              >
            </template>
            <template v-else>
              <input
                v-model="romanizationOfFirstName"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('romanizationOfFirstName') || romanFirstError }"
                type="text"
                name="romanizationOfFirstName"
                :data-vv-as="$t('Bao.romanization_of_first_name')"
                @input="validateRomFirstName"
              >
            </template>
            <div v-if="errors.has('romanizationOfFirstName')" class="input-feedback text-align-R">
              {{ $t('Bao.romanization_of_first_name_error') }}
            </div>
            <div v-else-if="romanFirstError" class="input-feedback text-align-R">
              {{ romanFirstError }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t("Bao.birthday") }}
              <span class="t-highlight">＊</span>
            </label>
            <template v-if="memberInfo.birthday">
              <input
                type="text"
                class="for-input inpType"
                :value="memberInfo.birthday"
                disabled
              >
            </template>
            <template v-else>
              <input
                v-model="updateUser.birthday"
                v-validate="'required|date_format:yyyy-MM-dd|before:' + maxDate"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('birthday') }"
                type="date"
                name="birthday"
                :data-vv-as="$t('Bao.birthday')"
                :max="maxDate"
              >
            </template>
            <div v-if="errors.has('birthday')" class="input-feedback text-align-R">
              {{ $t('Bao.birthday_error') }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t("Bao.address") }}
              <span class="t-highlight">＊</span>
            </label>
            <input
              v-model="updateUser.address"
              v-validate="'required'"
              class="for-input inpType"
              :class="{ 'isInvalid': errors.has('address') }"
              type="text"
              name="address"
              :placeholder="pleaseEnterTip('address')"
              :disabled="memberInfo.is_pass_KYC === 1"
            >
            <div v-if="errors.has('address')" class="input-feedback text-align-R">
              {{ $t('Bao.address_error') }}
            </div>
          </div>
        </div>

        <div class="verify-form-title">
          {{ $t("Bao.contact_info") }}
        </div>
        <div class="row-frame gx-3">
          <div class="colu-12">
            <label class="colu-12 for-label fs-14px fw-400" for="メールアドレス">{{ $t("Bao.e-mail") }}
              <span class="t-highlight">＊</span>
            </label>
          </div>
          <div class="colu colu-8 colu-md-9 colu-lg-10">
            <input
              v-if="memberInfo.email_validate === 0"
              id="eMail"
              v-model="updateUser.email"
              v-validate="'required'"
              class="for-input inpType"
              type="email"
              name="email"
              :placeholder="memberInfo.email"
            >
            <input
              v-else
              id="eMail"
              class="for-input inpType"
              type="text"
              name="check_lite_email"
              :value="memberInfo.email"
              :disabled="memberInfo.email_validate === 1"
            >
          </div>
          <div class="colu colu-4 colu-md-3 colu-lg-2">
            <button
              :disabled="memberInfo.email_validate === 1 && updateUser.email"
              class="btn btn-settings set-email btn-stroke button-style flex-fill"
              @click="goVerifyEmail"
            >
              {{ $t("Bao.setting") }}
            </button>
          </div>
        </div>

        <div class="row-frame gx-3">
          <div class="colu-8 colu-md-9 colu-lg-10 country-select-frame">
            <div class="colu">
              <div class="colu-4 colu-sm-3 colu-lg-2 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                <div class="form-select-1 country-select">
                  <div class="form-select-value">
                    <div class="country-flag" />
                    <div class="country-code">
                      {{ selectedCode }}
                    </div>

                    <div class="country-list-box">
                      <ul class="country-list">
                        <li
                          v-for="(code, key) in brand.supportPhoneCode"
                          :key="key"
                          @click.stop="selectCode(code)"
                        >
                          <div class="country-flag" />
                          <div class="country-code">
                            {{ code }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <i class="fa-solid fa-angle-right " aria-hidden="true" />
              </div>
              <div class="colu-8 colu-sm-9 colu-lg-10 number-box">
                <input
                  v-if="memberInfo.phone_validate === 0"
                  id="phoneNumber"
                  v-model="phone"
                  v-validate="'required'"
                  class="colu-12 for-input inpType"
                  :class="{ 'isInvalid': phoneError && phoneError !== $t('Bao.phone_available') }"
                  type="text"
                  autocomplete="off"
                  @input="phonecheck"
                >
                <input
                  v-if="memberInfo.phone_validate === 1"
                  id="phoneNumber"
                  :placeholder="updateUser.phone"
                  type="text"
                  class="colu-12 for-input inpType"
                  disabled
                >
                <div v-if="phoneError === $t('Bao.phone_available')" class="account_good text-align-R">
                  {{ phoneError }}
                </div>
                <div v-else-if="phoneError" class="input-feedback text-align-R">
                  {{ phoneError }}
                </div>
              </div>
            </div>
          </div>

          <div class="colu colu-4 colu-md-3 colu-lg-2">
            <button
              :disabled="memberInfo.phone_validate === 1 && updateUser.phone"
              class="btn btn-settings set-email btn-stroke button-style flex-fill"
              @click="goVerifyPhone"
            >
              {{ $t("Bao.setting") }}
            </button>
          </div>
        </div>

        <div class="verify-form-title">
          {{ $t("Bao.setting_password") }}
        </div>
        <div class="row-frame gx-3">
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t("Bao.modify") }}{{ $t("Bao.login_password") }}
            </label>
            <input
              ref="newPassword"
              v-model="updateUser.newPassword"
              v-validate="'min:6'"
              class="for-input inpType"
              :class="{ 'isInvalid': pwdError }"
              type="password"
              :placeholder="$t('Bao.please_leave_blank_if_not_set')"
              :data-vv-as="$t('Bao.newPassword')"
              name="newPassword"
              @input="pwdCheck"
            >
            <div v-if="pwdError" class="input-feedback text-align-R">
              {{ pwdError }}
            </div>
          </div>
          <div class="colu colu-12 colu-lg-6 flex-colu">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t("Bao.confirm") }}{{ $t("Bao.login_password") }}{{ $t("Bao.login_password_2") }}
            </label>
            <input
              v-model="updateUser.confirmPassword"
              v-validate="'min:6|confirmed:newPassword'"
              type="password"
              class="for-input inpType"
              :class="{ 'isInvalid': errors.has('confirmPassword') }"
              :placeholder="$t('Bao.please_leave_blank_if_not_set')"
              :data-vv-as="$t('Bao.confirmPassword')"
              name="confirmPassword"
              autocomplete="off"
            >
            <div v-if="errors.has('confirmPassword')" class="input-feedback text-align-R">
              {{ $t("Bao.confirm_password_error") }}
            </div>
          </div>
        </div>

        <div class="row-frame gx-3">
          <div class="colu colu-12">
            <label class="colu-12 for-label fs-14px fw-400">
              {{ $t("Bao.withdrawal_password") }}
            </label>
            <input
              v-if="memberInfo.withdrawal_pass === ''"
              v-model="updateUser.withdrawal_pass"
              v-validate="'required|min:4|max:4|integer'"
              class="for-input inpType"
              :class="{ 'isInvalid': errors.has('withdrawal_pass') }"
              type="password"
              :placeholder="pleaseEnterTip('withdrawal_pass')"
              :data-vv-as="$t('Bao.withdrawal_pass')"
              name="withdrawal_pass"
              maxlength="4"
            >
            <input
              v-else
              v-model="updateUser.withdrawal_pass"
              v-validate="'min:4|max:4|integer'"
              class="for-input inpType"
              :class="{ 'isInvalid': errors.has('withdrawal_pass') }"
              type="password"
              :placeholder="pleaseEnterTip('withdrawal_pass')"
              :data-vv-as="$t('Bao.withdrawal_pass')"
              name="withdrawal_pass"
              maxlength="4"
            >
            <div v-if="errors.has('withdrawal_pass')" class="input-feedback text-align-R">
              {{ $t('Bao.withdrawal_password_limit_error') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row-frame gy-3">
        <div class="colu colu-12">
          <button
            :disabled="isSendButtonDisabled"
            class="btn btn-kyc flex-fill"
            @click="save()"
          >
            <template v-if="kyc_brand && memberInfo.is_pass_KYC !== 1">
              {{ $t("Bao.KYC_has_third_completed_btn") }}
            </template>
            <template v-else>
              {{ memberInfo.is_pass_KYC === 0 ? $t("Bao.next") : $t("Bao.save_setting") }}
            </template>
          </button>
        </div>
      </div>

      <!-- 驗證彈窗 -->
      <div
        v-if="isShowVerifyEmail || isShowVerifyPhone"
        class="popup-wrap register-wrap fun-sec-authen"
        :class="{ active: isShowVerifyEmail || isShowVerifyPhone }"
      >
        <div class="popup-box fullScreen-md">
          <a class="popup-close" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>
          <div class="form-popup popup-padding">
            <form class="row-frame dep-form-frame reg-popupBox">
              <h4 class="register-title font-w-b text-align-L">
                <template v-if="isShowVerifyEmail">
                  {{ $t("Bao.verify_email") }}
                </template>
                <template v-if="isShowVerifyPhone">
                  {{ $t("Bao.verify_phone") }}
                </template>
              </h4>
              <div class="reg-form-group">
                <div class="reg-form-area">
                  <div class="colu colu-auto">
                    <label class="colu-12 colu-form-label title-label let-lessen">
                      <template v-if="isShowVerifyEmail">
                        {{ $t("Bao.verify_email_code") }}
                      </template>
                      <template v-if="isShowVerifyPhone">
                        {{ $t("Bao.verify_phone_code") }}
                      </template>
                    </label>
                    <div class="colu-12">
                      <input
                        v-if="isShowVerifyEmail"
                        v-model="verifyEmailCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowEmailError}"
                        type="text"
                        name="emailValidateCode"
                        autocomplete="off"
                        @input="validateEmailCode"
                      >
                      <input
                        v-if="isShowVerifyPhone"
                        v-model="verifyPhoneCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowPhoneError}"
                        type="text"
                        name="phoneValidateCode"
                        autocomplete="off"
                        @input="validatePhoneCode"
                      >
                    </div>
                    <div v-if="shouldShowEmailError || shouldShowPhoneError" class="input-feedback text-align-R">
                      {{ $t("Bao.validate_code_error") }}
                    </div>
                  </div>
                  <div>
                    <div class="form-button form-ft">
                      <button
                        class="btn btn-tertiary"
                        :disabled="isShowVerifyEmail ? isMailButtonDisabled : isPhoneButtonDisabled"
                        @click.prevent="isShowVerifyEmail ? verifyMail() : verifyPhone()"
                      >
                        <span>{{ $t("Bao.verify_register") }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="colu-auto">
                    <i class="icon-alert">
                      <img :src="$getThemeImagePath('icon-detail.png')" alt="">
                    </i>
                    <b>{{ $t("Bao.email_notice_4") }}</b>
                    <span v-if="isShowVerifyEmail" class="let-lessen">{{ $t("Bao.email_notice_5") }}</span>
                    <span v-if="isShowVerifyPhone" class="let-lessen">{{ $t("Bao.phone_notice_5") }}</span>
                  </div>
                  <div class="colu-auto">
                    <b>{{ $t("Bao.email_notice_1") }}</b>
                  </div>
                  <div class="colu-auto">
                    <p v-if="isShowVerifyEmail">
                      {{ $t("Bao.email_notice_2") }} {{ $t("Bao.email_notice_3") }}
                    </p>
                    <p v-if="isShowVerifyPhone">
                      {{ $t("Bao.phone_notice_3") }}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="authen-btn-wrap">
                  <button
                    class="btn-primary goTo-fun-sec-authen btn-mb-w-100 btn-resend"
                    :disabled="timerCount"
                    @click="getVerificationPop"
                  >
                    <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                    <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.get_verification_code') }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <iframe-verify v-if="verifyUrlFromStore" />
    </div>
  </div>
</template>

<script>
import { update, getPhoneCode, verifyPhoneCode, getEmailCode, verifyEmailCode, phoneCheck, getThirdPartyKycUrl } from '@/api/user'
import { setErrorMessage, showNotice } from '@/utils/tool'
import iframeVerify from '@/components/modal/iframeGame'
import { mapGetters } from 'vuex'

export default {
  components: {
    iframeVerify
  },
  data() {
    return {
      isShowVerify: false,
      updateUser: {},
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      romanLastError: '',
      romanFirstError: '',
      lastName: '',
      firstName: '',
      maxDate: new Date().toISOString().split('T')[0],
      isShowVerifyPhone: false,
      phone: '',
      verifyPhoneCode: '',
      isShowVerifyEmail: false,
      email: '',
      verifyEmailCode: '',
      timerCount: true,
      limitSecond: 180,
      isPhoneValid: false,
      phoneError: '',
      isPwdValid: true,
      pwdError: '',
      emailCodeTouched: false,
      phoneCodeTouched: false,
      isActive: false,
      selectedCode: '',
      phoneWithoutCode: ''
    }
  },
  computed: {
    ...mapGetters(['brand', 'user', 'memberInfo']),
    showKycTips() {
    // 如果有第三方 kyc 驗證
      if (this.kyc_brand) {
        return true
      }

      // 未經過驗證 或 已驗證的情況
      if (!this.kyc_brand &&
        (this.memberInfo.is_pass_KYC === 0 || this.memberInfo.is_pass_KYC === 1)) {
        return true
      }

      return false
    },
    kyc_brand() {
      return this.brand.info.kyc_brand !== 'self'
    },
    isSendButtonDisabled() {
      return this.memberInfo.email_validate === 0 || this.memberInfo.phone_validate === 0
    },
    isMailButtonDisabled() {
      return this.verifyEmailCode === null || this.verifyEmailCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.verifyPhoneCode === null || this.verifyPhoneCode.trim() === ''
    },
    verifyUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    isSetData() {
      return this.memberInfo.name !== '' && this.memberInfo.romanization !== '' &&
             this.memberInfo.birthday !== '' && this.memberInfo.address !== '' &&
             this.memberInfo.email_validate === 1 &&
             this.memberInfo.phone_validate === 1 &&
             this.memberInfo.withdrawal_pass !== ''
    },
    emailCodeInvalid() {
      return this.verifyEmailCode.trim() === ''
    },
    phoneCodeInvalid() {
      return this.verifyPhoneCode.trim() === ''
    },
    shouldShowEmailError() {
      return this.emailCodeTouched && this.emailCodeInvalid
    },
    shouldShowPhoneError() {
      return this.phoneCodeTouched && this.phoneCodeInvalid
    }
  },
  watch: {
    romanizationOfLastName(newLastName) {
      this.updateUser.romanization = newLastName + ',' + this.romanizationOfFirstName
    },
    romanizationOfFirstName(newFirstName) {
      this.updateUser.romanization = this.romanizationOfLastName + ',' + newFirstName
    },
    lastName(newLastName) {
      this.updateUser.name = newLastName + ',' + this.firstName
    },
    firstName(newFirstName) {
      this.updateUser.name = this.lastName + ',' + newFirstName
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          if (this.memberInfo.phone_validate === 1) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || ''
          } else if (this.memberInfo.phone_validate === 0 && this.memberInfo.phone) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || newVal[0]
          } else {
            this.selectedCode = newVal[0]
          }
        }
      },
      immediate: true
    },
    selectedCode(newCode) {
      if (this.memberInfo.phone && newCode) {
        const oldCode = this.brand.supportPhoneCode.find(code =>
          this.memberInfo.phone.startsWith(code)
        )
        if (oldCode) {
          this.phoneWithoutCode = this.memberInfo.phone.substring(oldCode.length)
        }
      }
    }
  },
  created() {
    this.initUpdateUser()
    this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
  },
  methods: {
    openIframe() {
      const kyc_url = this.$store.state.user.kyc_url
      if (kyc_url) {
        this.$store.commit('SET_GAME_URL', kyc_url)
        this.$store.commit('SET_KYC_VERIFY', true)
      } else {
        getThirdPartyKycUrl().then(response => {
          if (response.data.data.code === 0) {
            this.$store.commit('SET_GAME_URL', response.data.data.url)
            this.$store.commit('SET_KYC_VERIFY', true)
          } else {
            showNotice(response.data.data.message)
          }
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    pwdCheck() {
      const newPassword = this.updateUser.newPassword
      if (newPassword && newPassword.trim() !== '') {
        const passwordRegex = /^[a-zA-Z0-9]+$/ // Regex to allow only letters (uppercase and lowercase) and numbers
        if (!passwordRegex.test(newPassword)) {
          this.pwdError = this.$t('Bao.password_restrict_chars')
          this.isPwdValid = false
        } else if (newPassword.length < 6) {
          this.pwdError = this.$t('Bao.password_restrict')
          this.isPwdValid = false
        } else if (newPassword.length > 20) {
          this.pwdError = this.$t('Bao.password_restrict_20')
          this.isPwdValid = false
        } else {
          this.pwdError = ''
          this.isPwdValid = true
        }
      }
    },
    initUpdateUser() {
      this.romanizationOfLastName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[0] : ''
      this.romanizationOfFirstName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[1] : ''
      this.lastName = this.memberInfo.name ? this.memberInfo.name.split(',')[0] : ''
      this.firstName = this.memberInfo.name ? this.memberInfo.name.split(',')[1] : ''

      if (this.memberInfo.phone && this.selectedCode) {
        this.phone = this.memberInfo.phone.startsWith(this.selectedCode)
          ? this.memberInfo.phone.substring(this.selectedCode.length)
          : this.memberInfo.phone
      } else {
        this.phone = this.memberInfo.phone
      }

      this.updateUser = {
        romanization: this.memberInfo.romanization,
        name: this.memberInfo.name,
        newPassword: '',
        confirmPassword: '',
        withdrawal_pass: '',
        address: this.memberInfo.address,
        birthday: this.memberInfo.birthday,
        phone: this.phone,
        email: this.memberInfo.email
      }
    },
    phoneApiCall() {
      if (this.phone && this.phone.trim() !== '') {
        phoneCheck({ phone: this.selectedCode + this.phone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    getVerificationPop() {
      if (this.isShowVerifyEmail) {
        this.goVerifyEmail()
        return
      } else {
        this.goVerifyPhone()
      }
    },
    closeVerify() {
      this.isShowVerifyEmail = false
      this.isShowVerifyPhone = false
    },
    goVerifyPhone() {
      getPhoneCode({ phone: this.selectedCode + this.phone }).then(response => {
        this.countDown()
        showNotice(response.data.msg)
        this.isShowVerifyPhone = true
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    verifyPhone() {
      verifyPhoneCode(
        {
          phone: this.selectedCode + this.phone,
          validateCode: this.verifyPhoneCode
        }
      ).then(response => {
        this.isShowVerifyPhone = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    goVerifyEmail() {
      if (!this.updateUser.email && this.memberInfo.email) {
        this.updateUser.email = this.memberInfo.email
      }

      this.email = this.updateUser.email
      this.getMailCode(this.email)
    },
    getMailCode(mail) {
      getEmailCode({ email: mail }).then(response => {
        this.isShowVerifyEmail = true
        this.countDown()
        showNotice(response.data.msg)
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.isShowVerifyEmail = false
      })
    },
    verifyMail() {
      verifyEmailCode({ email: this.email, validateCode: this.verifyEmailCode }).then(response => {
        this.isShowVerifyEmail = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    save() {
      // lite player 只需輸入提款密碼即可保存
      if (this.memberInfo.member_type === 3) {
        this.updateUser.email = this.email
        this.updateUser.phone = this.selectedCode + this.phone
        update(this.updateUser).then(response => {
          showNotice(this.$t('Bao.update_success'))
          this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
          this.initUpdateUser()
        }).catch((error) => {
          setErrorMessage(error.response, this.errors)
        })
      } else {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            this.updateUser.email = this.email
            this.updateUser.phone = this.selectedCode + this.phone

            update(this.updateUser).then(response => {
              if (this.memberInfo.is_pass_KYC === 1) {
                showNotice(this.$t('Bao.update_success'))
              } else if (this.kyc_brand && this.memberInfo.is_pass_KYC !== 1) {
                this.openIframe()
              } else if (!this.kyc_brand) {
                this.$router.push('/user/KYC')
              }

              this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
              this.initUpdateUser()
            }).catch((error) => {
              setErrorMessage(error.response, this.errors)
            })
          }
        })
      }
    },
    pleaseEnterTip(filed) {
      return this.$t('Bao.' + filed) + '/' + this.$t('Bao.please_input')
    },
    isKatakana(str) {
      return /^[\u30A0-\u30FF\u31F0-\u31FF]*$/.test(str)
    },
    validateRomLastName() {
      if (!this.isKatakana(this.romanizationOfLastName)) {
        this.romanLastError = this.$t('Bao.katakana_only')
      } else if (this.isKatakana(this.romanizationOfLastName)) {
        this.romanLastError = ''
      }
    },
    validateRomFirstName() {
      if (!this.isKatakana(this.romanizationOfFirstName)) {
        this.romanFirstError = this.$t('Bao.katakana_only')
      } else if (this.isKatakana(this.romanizationOfFirstName)) {
        this.romanFirstError = ''
      }
    },
    validateEmailCode() {
      this.emailCodeTouched = true
    },
    validatePhoneCode() {
      this.phoneCodeTouched = true
    },
    toggleActive() {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = !this.isActive
    },
    selectCode(code) {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = false
      this.selectedCode = code

      if (this.phone && this.phone.trim() !== '') {
        this.debounceCheckPhone()
      }
    }
  }
}
</script>
